<script lang="ts">
import { Vue, Options } from 'vue-class-component';
import Camera from './elements/Camera.vue';
import axios from 'axios';
import { Resource } from '@/modules/core/files/services/StorageService';
import { Prop } from '@/helpers/Decorators';

@Options({
    components: { Camera },
    emits: ['photoUploaded', 'photoUploading', 'onClose', 'onOpen']
})
export default class RenterCamera extends Vue
{
    @Prop({ default: false }) public disabled: boolean;
    @Prop() public scope: string;

    public cameraView: boolean = false;
    public pending: boolean = false;

    public async handlePicture(picture: string): Promise<void>
    {
        const base64 = picture.replace('data:image/jpeg;base64,', '');

        this.pending = true;
        this.$emit('photoUploading', true);

        try
        {
            const { data } = await axios.post<Resource>(`admin/${this.scope}/uploadPhotosBase64`, base64, { headers: { 'Content-Type': 'application/json' } });

            this.$emit('photoUploaded', data as Resource);
        }
        catch (ex)
        {
            this.$log.debug(ex);
            this.$alert.warning(this.$t('[[[Przesyłanie zdjęcia nie powiodło się]]]'));
        }

        this.pending = false;
        this.$emit('photoUploading', false);
    }

    public closeCamera(): void
    {
        this.$emit('onClose');
        this.cameraView = false;
    }

    public showCamera(): void
    {
        this.cameraView = true;
        this.$emit('onOpen');
    }
}

</script>

<template>
    <action-button @click="showCamera" v-bind="$attrs" :text="pending ? $t('[[[Przesyłam...]]]') : $t('[[[Zrób zdjęcie]]]')" icon="fa-solid fa-camera" variant="success" :disabled="pending || disabled" />
    <camera v-if="cameraView" @onClose="closeCamera" @onPicture="(picture: string) => handlePicture(picture)" />
</template>
